import { SUPPORT_EMAIL_ADDRESS, UNSUBSCRIBED_BANNER_COPY } from '@frontend/constants';
import { Icon, Text, XStack, YStack, showToast } from '@frontend/web-react';
import { useEditProfileMutation, useRetrieveClientStatusQuery } from '@frontend/web/hooks';
import { handleMutation } from '@frontend/web/utils';

export const SubscriptionBanner = () => {
  const { data: clientStatus } = useRetrieveClientStatusQuery();
  const [editProfile, { isLoading: isActivating }] = useEditProfileMutation();

  const handleContactSupport = () => {
    navigator.clipboard
      .writeText(SUPPORT_EMAIL_ADDRESS)
      .then(() => {
        showToast({
          title: `The Duckbill support email address (${SUPPORT_EMAIL_ADDRESS}) has been copied to clipboard`,
          variant: 'info',
        });
      })
      .catch(() => {
        showToast({
          message: 'We could not copy the address automatically—please email us directly.',
          title: `Email ${SUPPORT_EMAIL_ADDRESS}`,
          variant: 'info',
        });
      });
  };

  const onClickBanner = async () => {
    if (isActivating) return;

    if (clientStatus?.membershipStatus === 'inactive') {
      await handleMutation({
        errorMessage: 'Unable to activate account. Please contact support.',
        mutation: () => editProfile({ membershipStatus: 'active' }).unwrap(),
        onError: handleContactSupport,
        onSuccess: () => {
          showToast({
            title: 'Your account has been successfully activated!',
            variant: 'success',
          });
        },
        showErrorToast: false,
        showSuccessToast: false,
      });
    } else {
      handleContactSupport();
    }
  };

  return (
    <XStack
      accessibilityLabel="Subscription banner"
      bg="rose50"
      borderColor="rose200"
      borderWidth={1}
      className="hover:cursor-pointer"
      gap="sm"
      onClick={onClickBanner}
      p="md"
      radius="lg"
      style={{ opacity: isActivating ? 0.6 : 1 }}
    >
      {/* eslint-disable-next-line tailwindcss/no-custom-classname */}
      <YStack className="size-12" radius="full">
        <Icon iconClassName="stroke-rose-700" name="IconAlertCircle" size={20} />
      </YStack>
      <YStack className="gap-xs">
        <Text className="text-rose-800" isSelectable={false} type="h5">
          {UNSUBSCRIBED_BANNER_COPY.title}
        </Text>
        <Text className="text-rose-700" isSelectable={false} type="p-sm">
          {UNSUBSCRIBED_BANNER_COPY.description}{' '}
          {clientStatus?.membershipStatus === 'inactive'
            ? 'Click to reactivate or contact support.'
            : 'Click to contact support and resubscribe.'}
        </Text>
      </YStack>
    </XStack>
  );
};
